module.exports = __webpack_public_path__ + "static/media/shazam.a61d9fd2.jpg";